var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendarCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2527",
    x: 1,
    y: 1,
    width: 16,
    height: 14,
    rx: 3,
    stroke: "#EE5294",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2528",
    d: "M0 4C0 1.79086 1.79086 0 4 0H14C16.2091 0 18 1.79086 18 4V5H0V4Z",
    fill: "#EE5294"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5470",
    x: 4,
    y: 6,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#EE5294"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5473",
    x: 4,
    y: 10,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#EE5294"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5471",
    x: 8,
    y: 6,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#EE5294"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5474",
    x: 8,
    y: 10,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#EE5294"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5472",
    x: 12,
    y: 6,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#EE5294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1087",
    d: "M12 10L14 12",
    stroke: "#EE5294",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1088",
    d: "M14 10L12 12",
    stroke: "#EE5294",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarCu);
export default __webpack_public_path__ + "static/media/icon-calendar-cu.6c5956c45c589cfde9fbf94c89940b55.svg";
export { ForwardRef as ReactComponent };